import { Setting } from '@/models/admins.model'
import { PeriodData } from '@/models/ve.model'
import type { AppDispatch } from '@/redux/store'
import type { AsyncThunkAction } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import toast from 'react-hot-toast'

var Cryto = require('crypto-js')

dayjs.extend(customParseFormat)

export const randomString = (length: number): string => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = length
  let counter = 0

  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }

  return result
}

const CIPHER_KEY = Cryto.enc.Utf8.parse(process.env.NEXT_PUBLIC_SECRET)

// Encrypts plain text into cipher text
// export const encryptData = (plainText: string): string => {
//   const iv = Cryto.randomBytes(BLOCK_SIZE)
//   const cipher = Cryto.createCipheriv(ALGORITHM, CIPHER_KEY, iv)
//   let cipherText

//   try {
//     cipherText = cipher.update(plainText, 'utf8', 'hex')
//     cipherText += cipher.final('hex')
//     cipherText = iv.toString('hex') + cipherText
//   } catch (e) {
//     cipherText = null
//   }

//   // console.log('encrypt', plainText, cipherText)
//   return cipherText
// }

// Decrypts cipher text into plain text
// export const decryptData = (cipherText: string): string => {
//   const contents = Buffer.from(cipherText, 'hex')
//   const iv = contents.subarray(0, BLOCK_SIZE)
//   const textBytes = contents.subarray(BLOCK_SIZE)

//   const decipher = Cryto.createDecipheriv(ALGORITHM, CIPHER_KEY, iv)
//   let decrypted = decipher.update(textBytes, 'hex', 'utf8')
//   decrypted += decipher.final('utf8')

//   // console.log('decrypt', cipherText, decrypted)
//   return decrypted
// }

export const encryptData = (plaintText: string): string => {
  //encrypt
  var encryptedData = Cryto.AES.encrypt(plaintText, CIPHER_KEY, {
    mode: Cryto.mode.ECB,
    padding: Cryto.pad.Pkcs7
  })
  // console.log('plaintText：' + plaintText)
  // console.log('encryptedData ：' + encryptedData)

  var encryptedDataHexStr = encryptedData.toString(Cryto.format.Hex)
  // console.log('encryptedDataHex：' + encryptedDataHexStr)

  return encryptedDataHexStr
}

//decrypt 
export const decryptData = (cipherText: string): string => {
  var encryptedHex = Cryto.enc.Hex.parse(cipherText)
  var encryptedBase64 = Cryto.enc.Base64.stringify(encryptedHex)
  // console.log('encryptedHex  ：' + encryptedHex)
  // console.log('encryptedBase64  ：' + encryptedBase64)

  var decryptedData = Cryto.AES.decrypt(encryptedBase64, CIPHER_KEY, {
    mode: Cryto.mode.ECB,
    padding: Cryto.pad.Pkcs7,
  })

  let decryptText = decryptedData.toString(Cryto.enc.Utf8)
  // console.log('decryptText ：' + decryptText)

  return decryptText
}

// Period
export const getPeriodEvaluate = (): PeriodData => {
  /**
   * Half 1 Jan-June Evaluate July same year
   * Half 2 July-Dec Evaluate Jan next year
   */
  const month = parseInt(dayjs().format('M'))
  const year = dayjs().year()
  let evaHalf = 1
  let evaYear = year

  console.log('MONTH', month, year)

  if (month <= 6) { // 0 - 6
    evaHalf = 2
    evaYear = year - 1
  } else if (month >= 7) { // 7 - 12
    evaHalf = 1
  }

  let period = `${evaHalf}/${evaYear}`
  console.log('PERIOD', period)

  let data: PeriodData = {
    period,
    evaHalf,
    month,
    year,
    evaYear
  }

  return data
}

// Month range
export const getPeriodMonth = (period?: string): string => {
  const [evaHalf, evaYear] = period ? period.split('/').map(Number) : [getPeriodEvaluate().evaHalf, getPeriodEvaluate().evaYear]

  if (evaHalf == 2) {
    return `July-Dec (${evaYear})`
  } else if (evaHalf == 1) {
    return `Jan-Jun (${evaYear})`
  }

  return ''
}

// Babber setting
export const getSettingBanner = (data: Setting): string => {
  const periodData = getPeriodEvaluate()
  let bannerText = ''

  if (periodData.evaHalf == 1) {
    bannerText = `Start ${data.half1_start} - ${data.half1_end}`
  } else if (periodData.evaHalf == 2) {
    bannerText = `Start ${data.half2_start} - ${data.half2_end}`
  }

  return bannerText
}

// Check in period evaluate
export const checkOpenEvaluate = (periodData: PeriodData, setting: Setting): boolean => {
  let startDate = ''
  let endDate = ''
  let newStart = ''
  let newEnd = ''
  let nowYear = dayjs().year()

  if (periodData.evaHalf == 2) {
    newStart = dayjs(setting.half2_start).format('MM-DD')
    newEnd = dayjs(setting.half2_end).format('MM-DD')
  } else {
    newStart = dayjs(setting.half1_start).format('MM-DD')
    newEnd = dayjs(setting.half1_end).format('MM-DD')
  }

  startDate = `${nowYear}-${newStart}`
  endDate = `${nowYear}-${newEnd}`

  const nowDate = dayjs().format('YYYY-MM-DD')
  console.log(nowDate, startDate, endDate)
  const date = new Date(nowDate)
  const start = new Date(startDate)
  const end = new Date(endDate)

  return (date >= start && date <= end) ? true : false
}

// Run a redux-toolkit thunk: toast on reject, else hand the payload to `ok`.
// Replaces the dispatch(...).then(check rejected).catch(log;throw) block repeated across views.
// `T` is inferred from `action`, so `ok` is checked against the thunk's real payload type.
export const runThunk = async <T>(
  dispatch: AppDispatch,
  action: AsyncThunkAction<T, any, any>,
  ok: (data: T) => void,
  msg = 'Failed: Please try again later.'
): Promise<void> => {
  const res = await dispatch(action)
  if (res.meta.requestStatus === 'rejected') {
    toast.error(msg)
    return
  }
  ok((res as { payload: T }).payload)
}

// Read the caller's department context from localStorage (client-side only).
// localStorage is synchronous — no await needed at call sites.
export const getDepartment = () => ({
  cost_center: localStorage.getItem('isz_cost_center') || '',
  comp_code: localStorage.getItem('isz_comp_code') || '',
  sales_group: localStorage.getItem('isz_sales_group') || 'N',
  department: localStorage.getItem('isz_department') || '',
  division: localStorage.getItem('isz_division') || '',
})